import './localization';
import './features/analytics/initialize';
import { configs } from '@app/configs';
import * as Sentry from '@sentry/react';
import WebFont from 'webfontloader';
import { landingPageLanguageReferrer } from './helpers/landingPageLanguageReferrer';
import { supportedLanguages } from './i18next.config';
Sentry.init({
    dsn: configs.SENTRY_DSN,
    ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS',
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        'Can\'t find variable: ZiteReader',
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        // Facebook borked
        'fb_xd_fragment',
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
        // reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        'conduitPage',
        // Google Translate extension
        // See: https://medium.com/@amir.harel/a-b-target-classname-indexof-is-not-a-function-at-least-not-mine-8e52f7be64ca
        'a[b].target.className.indexOf is not a function',
    ],
});
WebFont.load({
    google: {
        families: ['Source Sans Pro:300,400,600,700', 'sans-serif'],
    },
});
landingPageLanguageReferrer(supportedLanguages);
